import { render, staticRenderFns } from "./ProductGalleryComponent.vue?vue&type=template&id=3aee847d"
import script from "./ProductGalleryComponent.vue?vue&type=script&lang=js"
export * from "./ProductGalleryComponent.vue?vue&type=script&lang=js"
import style0 from "./ProductGalleryComponent.vue?vue&type=style&index=0&id=3aee847d&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports